import * as z from "zod/mini";

/** The applicants page's tabs, as its `tab` search param names them; the chat links to them too. */
export const APPLICANTS_TABS = ["applied", "matches", "offered", "cancelled", "declined"] as const;
export type ApplicantsTab = (typeof APPLICANTS_TABS)[number];

export const applicantsSearchSchema = z.object({
  selection: z.optional(z.array(z.number())),
  // Optional: with none, the page opens on Offered when offers are pending, else on its first tab.
  tab: z.optional(z.enum(APPLICANTS_TABS)),
});
